import * as uuid from "uuid/v4";

const EVENT_NAME = 'knowledge_base_link_transition';
const USERDATA_URL = 'https://userevents.domclick.ru/api/v1/events';

function goToLK(event) {
    event.preventDefault();
    const data = {
        name: EVENT_NAME,
        uuid: uuid(),
        event_data: {
            url: document.URL,
            target: this.href,
        }
    };

    fetch(USERDATA_URL, {method: 'POST', body: JSON.stringify(data), credentials: "include"})
        .finally(() => {
            window.location = this.href;
        });
}

window.addEventListener('load', () => {
    // document.getElementsByClassName('transfer-link').forEach((el) => {
    //     el.onclick = goToLK;
    // })
});

